<template>
  <page>
    <page-header-new
      :title="$t('LeftNavigation_CustomerIntelligence_CampaignROI')"
    >
    </page-header-new>
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import PageHeaderNew from '@/common/components/page/PageHeaderNew'
export default {
  name: 'CampaignROIPage',
  components: { PageHeaderNew, Page }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/customer-intelligence/pages/CampaignROIPage.vue